import { useEffect, useState } from "react";
import { LocationRecipe } from "./LocationRecipe";
import type { LocationBreakdownType } from "@/lib/requests/getLocationBreakdown";
import type { LinkType } from "./shared";
import type { performViatorProductSearch } from "@/lib/requests/ads/viator";

export function LocationRecipeWithClientViator({
  lat,
  lng,
  country,
  city,
  locationBreakdown,
  introLinks,
  idPrefix = "",
}: {
  lat: string;
  lng: string;
  country: string;
  city?: string;
  locationBreakdown: LocationBreakdownType;
  introLinks: LinkType[];
  idPrefix?: string;
}) {
  const [viatorData, setViatorData] = useState<{
    products: Awaited<ReturnType<typeof performViatorProductSearch>>;
  }>({
    products: [],
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchViatorData = async () => {
      try {
        console.log(
          `Fetching Viator data for: ${city ? `${city}, ${country}` : country}`,
        );

        // Build URL with query parameters
        const params = new URLSearchParams({
          country,
          lat,
          lng,
        });

        // Only add city if it exists
        if (city) {
          params.append("city", city);
        }

        const response = await fetch(
          `/api/viator-products.json?${params.toString()}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch Viator data: ${response.status}`);
        }

        const data = await response.json();
        setViatorData(data);
      } catch (error) {
        console.error("Error fetching Viator data:", error);
        setViatorData({ products: [] });
      } finally {
        setIsLoading(false);
      }
    };

    fetchViatorData();
  }, [city, country, lat, lng]);

  return (
    <LocationRecipe
      country={country}
      city={city}
      locationBreakdown={locationBreakdown}
      viator={viatorData}
      lat={lat}
      lng={lng}
      introLinks={introLinks}
      idPrefix={idPrefix}
      isViatorLoading={isLoading}
    />
  );
}
